import { render, staticRenderFns } from "./PageHeadings.vue?vue&type=template&id=385dfebe&scoped=true&"
import script from "./PageHeadings.vue?vue&type=script&lang=js&"
export * from "./PageHeadings.vue?vue&type=script&lang=js&"
import style0 from "./PageHeadings.vue?vue&type=style&index=0&id=385dfebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385dfebe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCol,VContainer,VImg,VRow,VSheet})
